import React, { useState } from "react";

import {
  ExpandLess,
  ExpandMore,
  HelpCenterOutlined,
  InfoOutlined,
  TimerOutlined,
} from "@mui/icons-material";
import { Box, Typography, Paper, Chip, IconButton } from "@mui/material";

import QnaRating from "./QnaRating";
import Logo from "../assets/images/app-logo-single.webp";
import { getCamelCaseWord } from "../utils/functions";
import { Link } from "react-router-dom";

const InterviewQnaCard = ({ qna, language }) => {
  const [expanded, setExpanded] = useState(true);
  const isArabic = language === "Arabic"; // Check for Arabic language
  const parsedAnswerText = (() => {
    try {
      const parsed = JSON.parse(qna?.answer_text);
      return Array.isArray(parsed) ? parsed[0] : qna?.answer_text;
    } catch (error) {
      return qna?.answer_text;
    }
  })();
  return (
    <Paper elevation={0} sx={{ p: 3, mt: 2, bgcolor: "#f8f9fa", borderRadius : 3 }}>
      {/* Header with Suggested and Rating */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            src={Logo}
            component="img"
            sx={{ width: "19px", height: "25px" }}
          />
          {qna?.suggested && (
            <Typography fontWeight={500} sx={{ fontSize: "0.875rem" }}>
              Suggested
            </Typography>
          )}
          <QnaRating value={(qna?.answer_score / 100) * 5} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <IconButton
              size="small"
              sx={{
                width: "24px",
                height: "24px",
                border: "1px solid #d1d1d1",
              }}
            >
              <HelpCenterOutlined
                sx={{ width: "14px", height: "14px", color: "#999" }}
              />
            </IconButton>
            <Typography fontFamily="Outfit" fontSize="12px" noWrap>
              {getCamelCaseWord(qna?.question_category)}
            </Typography>

            <IconButton
              size="small"
              sx={{
                width: "24px",
                height: "24px",
                border: "1px solid #d1d1d1",
              }}
            >
              <TimerOutlined
                sx={{ width: "14px", height: "14px", color: "#999" }}
              />
            </IconButton>
            <Typography fontFamily="Outfit" fontSize="12px" noWrap>
              {qna?.test_time}
            </Typography>
          </Box>
          <IconButton
            size="small"
            sx={{ color: "#666" }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>
      </Box>
      {expanded && (
        <>
          {/* Question */}
          <Box sx={{ mb: 2 }}>
            <Chip
              label="Question"
              size="small"
              sx={{
                bgcolor: "#4CC4FF",
                color: "white",
                fontSize: "0.75rem",
                height: 24,
                mb: 1,
              }}
            />
            <Typography
              sx={{
                color: "#2C3E50",
                fontSize: "0.875rem",
                lineHeight: 1.5,
                direction: isArabic ? "rtl" : "ltr",
                textAlign: isArabic ? "right" : "left",
              }}
            >
              {qna?.message}
            </Typography>
          </Box>

          {/* Expected Answer */}
          <Box sx={{ mb: 2 }}>
            <Chip
              label="Expected Answer"
              size="small"
              sx={{
                bgcolor: "#4CC4FF",
                color: "white",
                fontSize: "0.75rem",
                height: 24,
                mb: 1,
              }}
            />
            <Typography
              sx={{
                color: "#2C3E50",
                fontSize: "0.875rem",
                lineHeight: 1.5,
                direction: isArabic ? "rtl" : "ltr",
                textAlign: isArabic ? "right" : "left",
              }}
            >
              {qna?.expected_answer}
            </Typography>
          </Box>

          {/* Candidate Answer */}
          <Box sx={{ mb: 2 }}>
            <Chip
              label="Candidate answer"
              size="small"
              sx={{
                bgcolor: "#FFB400",
                color: "white",
                fontSize: "0.75rem",
                height: 24,
                mb: 1,
              }}
            />
            <Typography
              sx={{
                color: "#2C3E50",
                fontSize: "0.875rem",
                lineHeight: 1.5,
                direction: isArabic ? "rtl" : "ltr",
                textAlign: isArabic ? "right" : "left",
              }}
            >
              {parsedAnswerText}
            </Typography>
          </Box>
        </>
      )}
      {/* Match Score */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 2,
          color: "#666",
          fontSize: "0.75rem",
        }}
      >
        <InfoOutlined sx={{ fontSize: "14px", mr: 0.5 }} />
        <Typography
          component="span"
          sx={{ fontSize: "0.75rem", color: "#666" }}
        >
          The answer matched {Math.round(qna?.answer_score || 0)}% of the
          expected answer.
        </Typography>
        <Typography
          sx={{
            fontSize: "0.75rem",
            color: "#1CCCF0",
            ml: 0.5,
            fontWeight: "bold",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Expected answer
        </Typography>
      </Box>
    </Paper>
  );
};

export default InterviewQnaCard;
